import { createQuestionValueMap, mapToTupleArray, PageJson } from "../../../../common/summary-common/applicationSummary";
import { ConfirmationData, updateMapWithFields } from "../../../../common/summary-common/confirmationData";

export const defaultReferralInformation: Map<string, ConfirmationData> = new Map([
    ["d64bc00a-8be9-4bfc-9759-bdee3831a5a1", { fontWeight: "bold" }],
    ["6a24cbca-3b5e-48dd-89ab-fbb6bb1c6978-opt1", { type: "checkbox" }],
    ["6a24cbca-3b5e-48dd-89ab-fbb6bb1c6978-opt2", { type: "checkbox" }],
    ["6a24cbca-3b5e-48dd-89ab-fbb6bb1c6978-opt3", { type: "checkbox" }],
    ["6a24cbca-3b5e-48dd-89ab-fbb6bb1c6978-opt4", { type: "checkbox" }],
    ["6a24cbca-3b5e-48dd-89ab-fbb6bb1c6978-opt5", { type: "checkbox" }],
    ["6a24cbca-3b5e-48dd-89ab-fbb6bb1c6978-opt6", { type: "checkbox", showBorder: true }],
]);

export const adviser: Map<string, ConfirmationData> = new Map([
    ["Asesor", { label: "Asesor", value: "", fontWeight: "bold" }],
    ["684f421b-3eaf-4c15-b3c5-22a87bf0b617", { value: "", showBorder: true }],
])

export const others: Map<string, ConfirmationData> = new Map([
    ["Otros", { label: "Otros", value: "", fontWeight: "bold" }],
    ["e526fb9e-1e1f-451a-b6ac-2222943f7a8f", { }]
])

export const updateReferralInformation = (page: PageJson | undefined, cd: Map<string, ConfirmationData>): Map<string, ConfirmationData> => {
    if (page === undefined) {
        return new Map();
    }
    const answersMap = createQuestionValueMap(page);

    if (answersMap.get("6a24cbca-3b5e-48dd-89ab-fbb6bb1c6978-opt1")?.value === "SI") {
        cd = new Map([
            ...cd,
            ...adviser,
        ]);
    }

    if (answersMap.get("6a24cbca-3b5e-48dd-89ab-fbb6bb1c6978-opt6")?.value === "SI") {
        cd = new Map([
            ...cd,
            ...others,
        ]);
    }
    return updateMapWithFields(mapToTupleArray(answersMap), cd);
}